import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
  // <App />
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/*
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import React from "react";
import MapSearchBar from "./MapSearchBar";
// index.js or App.js
import ReactDOM from "react-dom";
import SearchingParent from "./SearchingParent";

const data = [
  {
    name: "New York",
    type: "City",
    coordinates: { latitude: 40.7128, longitude: -74.006 },
  },
  {
    name: "Los Angeles",
    type: "City",
    coordinates: { latitude: 34.0522, longitude: -118.2437 },
  },
  {
    name: "Golden Gate Park",
    type: "Park",
    coordinates: { latitude: 37.7694, longitude: -122.4862 },
  },
  // Add more locations with necessary details
];

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

/*root.render(
  <StrictMode>
    <SearchingParent data={data} />
  </StrictMode>
);*/
/*
ReactDOM.render(
  <React.StrictMode>
    <SearchingParent data={data} />
  </React.StrictMode>,
  document.getElementById("root")
);*/